/** 견적 그림 자리의 두 주소 — 견적 사본 썸네일과 상품 대표 사진(일반 견적에만). */
interface QuoteImageSource {
  readonly thumbnailUrl: string | null;
  readonly productImageUrl: string | null;
}

/**
 * 견적 그림의 대체 문구. 썸네일이 없고 상품 사진을 대신 보일 때(일반 견적)는 "<상품명> 상품 사진", 그 밖에는 호출자의 디자인
 * 미리보기 문구 그대로다. 그림 주소는 화면이 `thumbnailUrl ?? productImageUrl` 로 고른다.
 */
export const quoteImageAlt = (
  source: QuoteImageSource,
  productName: string,
  designAlt: string,
): string =>
  source.thumbnailUrl === null && source.productImageUrl !== null
    ? `${productName} 상품 사진`
    : designAlt;
